import { createContext, useContext, useState } from 'react';

const AppConfigModalContext = createContext(null);

export function AppConfigModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const value = {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };

  return <AppConfigModalContext.Provider value={value}>{children}</AppConfigModalContext.Provider>;
}

export const useAppConfigModal = () => useContext(AppConfigModalContext);
